import React from "react";
import Container from "react-bootstrap/esm/Container";
import UsersTable from "../../components/tables/usersTable";
import { ColumnDef } from "@tanstack/react-table";
import { fuzzySort } from "../../components/tables/fuzzySort";
import {
  Admin,
  listOrganizationAdmins,
} from "../../api/listOrganizationAdmins";
import { listOrganizationAgencies } from "../../api/listOrganizationAgencies";

export default function AdminAllAgencies() {
  const columns = React.useMemo<ColumnDef<Admin, any>[]>(
    () => [
      {
        accessorFn: (row) => row.displayName,
        id: "displayName",
        header: "Name",
        cell: (info) => {
          return <strong>{info.getValue()}</strong>;
        },
        footer: (props) => props.column.id,
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },
      {
        accessorFn: (row) => row.userName,
        id: "userName",
        header: "Username",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },
      {
        accessorFn: (row) => row.email,
        id: "email",
        header: "Email",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },
      {
        accessorFn: (row) => row.status,
        id: "status",
        header: "Status",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },
    ],
    []
  );

  return (
    <div className="py-5">
      <Container fluid>
        <h1 className="text-primary mb-5">Agencies</h1>
        <UsersTable
          columns={columns}
          lookupList={listOrganizationAgencies}
          role={"agency"}
        />
      </Container>
    </div>
  );
}
